// src/main.tsx
import React from 'react'
import ReactDOM from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n'
import App from './App'
import { ChatBotProvider } from './contexts/ChatBotContext'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <ChatBotProvider>
        <App />
      </ChatBotProvider>
    </I18nextProvider>
  </React.StrictMode>
)
